import { useState } from 'react';
import Scanner from '../components/Scanner';
import API_ROOT from '../config';
import { useFetch } from './Launchpad';
import { PrimaryButton, SecondaryButton } from '../components/Button';

function Revoke({ tenant, onDone }) {
  const [qrCode, setQrCode] = useState('');
  const [message, setMessage] = useState('');
  const [notes, setNotes] = useState('');
  const { fetchWithAuth } = useFetch();

  const revokeLicense = async () => {
    const options = {
      method: 'DELETE',
      body: JSON.stringify({ 
        timestamp:new Date().toISOString(), 
        request_base64: qrCode,
        additional_parameters: [
          `Notes=${notes}`
        ]
       })
    };

    const response = await fetchWithAuth(`${API_ROOT}/license/${tenant}`, options);
    
    if (response.status === 404) {
      setMessage('License not found.');
      return;
    }
    if (!response.ok) {
      let errorText = await response.text();
      const errorPrefix = 'Unable to revoke license: ';
      try {
        let errorData = JSON.parse(errorText);
        setMessage(errorPrefix + (errorData.Message ?? ""));
      }
      catch (e) {
        setMessage(errorPrefix + errorText);
      }
      console.error(errorPrefix, response);
      return;
    }
    if (response.status === 204) {
      setMessage('License revoked successfully.');
      return;
    }
    if (response.status === 208) {
      setMessage('License already revoked.');
      return;
    }
    const responseMessage = await response.text();
    setMessage(responseMessage);
  }

  const clear = () => {
    setQrCode('');
    setMessage('');
  }  
  return (
    <div>
      {qrCode ? 'Code scanned successfully' : <div>
            Set the cabinet to audit mode and scan the QR code to revoke the license.
                <Scanner onScan={setQrCode} />
                </div>}
      
      <textarea
                disabled={!!message}
                className="form-control my-2"
                placeholder="Notes"
                value={notes}
                onChange={e => setNotes(e.target.value)}
            />
            
      <div>{message}</div>
      {
      !message 
        ? <PrimaryButton disabled={!qrCode} onClick={revokeLicense}>Revoke</PrimaryButton> 
        : <SecondaryButton onClick={clear}>Revoke another license</SecondaryButton>
      }

      <SecondaryButton onClick={onDone}>{message ? "Done" : "Cancel"}</SecondaryButton>  
    </div>
  );
}

export default Revoke;